import m from 'mithril'

import Layout from 'core/components/Layout'
import Intro from 'info/components/Intro'

import sceneData from 'panorama/data/scenes'
import overlayData from 'info/data/overlays'
import transitionData from 'panorama/data/transitions'

import { getScenesById } from 'panorama/helpers'

const parseData = vnode => {
  const scene = sceneData.find(scene => scene.id === vnode.attrs.scene)
  const transition = transitionData.find(transition => transition.id === vnode.attrs.transition)
  const overlay = overlayData.find(overlay => overlay.id === vnode.attrs.overlay)
  const preload = getScenesById(sceneData, (scene || []).preload || [])

  return {
    scenes: sceneData,
    scene,
    preload,
    transition,
    overlay,
    y: vnode.attrs.y ? Number(vnode.attrs.y) : null,
    p: vnode.attrs.p ? Number(vnode.attrs.p) : null,
    f: vnode.attrs.f ? Number(vnode.attrs.f) : null
  }
}

export default {
  init: targetDomElement => {
    m.route(targetDomElement, '/pano/outside?overlay=intro-video', {
      // '/': {
      //   render: vnode => {
      //     const preload = getScenesById(sceneData, ['outside'])
      //     return (
      //       <Layout {...vnode.attrs} preload={preload}>
      //         <Intro {...vnode.attrs} />
      //       </Layout>
      //     )
      //   }
      // },
      '/pano/:scene': {
        render: vnode => {
          const data = parseData(vnode)
          return <Layout {...vnode.attrs} {...data} />
        }
      },
      '/404': { view: () => <div className="error">404</div> }
    })
  }
}
